/* eslint-disable react/require-default-props */
import React from 'react';
import { useIntl } from 'react-intl';
import { FlexColumn, Input } from 'design-system';

export default function NumberTypeAnswer({
  preview = false,
  value = '',
  onChange,
  interactive = false,
  hasError = false,
}) {
  const intl = useIntl();

  return (
    <FlexColumn align="stretch" fullWidth className={preview ? 'cc-preview-number-answer' : 'mt-2'}>
      <Input
        type="number"
        readOnly={preview && !interactive}
        className={preview ? 'cc-preview-number-answer__field' : 'text-input'}
        placeholder={intl.formatMessage({ id: 'enter-number' })}
        value={value ?? ''}
        error={hasError}
        onChange={(event) => onChange?.(event.target.value)}
      />
    </FlexColumn>
  );
}
